import { GoodsNutrientRegistModel } from './vo/goods-nutrient-regist.model';
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { GetGoodsNutrientComponentListService } from './api-services/get-goods-nutrient-component-list.service';
import { GoodsNutrientModel } from './vo/goods-nutrient.model';
import { KYMW1107OutputModel } from '../kymw1100/vo/kymw1107-output.model';
import { KYMW1107InputModel } from '../kymw1100/vo/kymw1107-input.model';
import { NotNullTextAreaComponent } from './../../../commons/kymw02/not-null-text-area/not-null-text-area.component';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1107Model } from './kymw1107.model';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { RegistNutrientInfoService } from './api-services/regist-nutrient-info.service';
import { EventArgs } from '@grapecity/wijmo';

/**
 * 商品栄養成分情報メンテナンス画面を管理するクラス
 *
 * @export KYMW1107Component
 * @class KYMW1107Component
 */
@Component({
  selector: 'app-kymw1107',
  templateUrl: 'kymw1107.component.html',
  styleUrls: ['kymw1107.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1107Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dg_NutrientComponentList', { static: true }) dg_NutrientComponentList: FlexGrid;
  @ViewChild('txta_AnalysisUnit', { static: true }) txta_AnalysisUnit: NotNullTextAreaComponent;
  @ViewChild('nutritionalQuantity1', { static: true }) nutritionalQuantity1: ElementRef;

  // 親画面からの連携値
  param: any;

  kymw1107Model: KYMW1107Model = new KYMW1107Model();

  /**
		 * 画面受渡情報
		 * 画面呼び出し時に受け渡されるオブジェクト
		 */
  private inputVO: KYMW1107InputModel;

  public setKYMW1107Parameter: Function;

  /**
   *Creates an instance of KYMW1107Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1107Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getGoodsNutrientComponentListService: GetGoodsNutrientComponentListService,
    private registNutrientInfoService: RegistNutrientInfoService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1107Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1107';
    this.kymw1107Model.kymw1107Component = this;
    // this.dg_NutrientComponentList.selectionMode = SelectionMode.Row;
    // 画面から引き渡された値をManageに反映させる
    this.kymw1107Model.pCode = this.inputVO.pCode;                              // Ｐコード
    this.kymw1107Model.itemCode = this.inputVO.itemCode;                        // アイテムコード
    this.kymw1107Model.guideGoodsName = this.inputVO.guideGoodsName;            // 商品案内用商品名
    this.kymw1107Model.guideStandardName = this.inputVO.guideStandardName;      // 商品案内用規格名
    this.kymw1107Model.analysisSeqNo = this.inputVO.analysisSeqNo;              // 分析連番

    this.dg_NutrientComponentList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dg_NutrientComponentList.select(-1, -1);
    });

    // 商品栄養成分情報一覧取得処理
    this.eventInfoSet_CLICKHandler();

    // 編集済みチェック用に、イベントを割り当て
    this.eventListenerSetting();

    // グリッドの初期選択行はなしとする
    this.dg_NutrientComponentList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dg_NutrientComponentList.select(-1, -1);
    });
  }

  public setInterfaceParam(param: any) {
    this.inputVO = <KYMW1107InputModel>param;
  }

  /**
 *
 * @param {*} param 受け渡すデータ
 * @memberof KYMW1107InputVO
 */
  public setInputVO(param: any): void {
    // 受渡情報の設定
    this.inputVO = <KYMW1107InputModel>param;
    // 初期処理を呼び出す
    this.ngOnInit();
  }

  public eventInfoSet_CLICKHandler(): void {
    // 商品栄養成分情報一覧取得処理
    this.getGoodsNutrientComponentListService.execute(this.kymw1107Model, this.inputVO);
  }

  /**
   * @copy jp.co.toppan.pless.common.view.PlessViewHelper#eventListenerSetting()
   */
  public eventListenerSetting(): void {
    /**
     * 編集済みチェック用に、イベントを割り当て
     */
    const changeObj: Array<string> = [
      'txta_AnalysisUnit'
      , 'txta_NutritionalNote'
      , 'dg_NutrientComponentList'
    ];

    for (let i = Number(0); i < changeObj.length; i++) {
      document.getElementById(changeObj[i]).addEventListener('change', () => this.eventEditHandler());
    }
  }

  /**
   * 項目変更時イベント
   */
  public eventEditHandler(): void {
    this.kymw1107Model.isEdited = true;
  }

  /**
   * 「閉じる」
   *
   * @param event コールバック・イベントへの参照
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.kymw1107Model.isEdited) {
      this.dialogService.openAlertGetMessage('Q0107', ['栄養成分情報'], (closeEvent: number) => {
        if (closeEvent === PlessAlert.Yes) {
          this.onClickClose();
        }
      });
    } else {
      super.onClickClose();
    }
  }

  /**
   * 設定ボタンを押下したときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSet_CLICKHandler(): void {
    // 編集有無の確認
    if (!this.kymw1107Model.isEdited) {
      this.dialogService.openAlertGetMessage('E0162');
      return;
    }
    // 商品栄養成分リストの栄養成分値すべてにデータがなかった場合
    if (!this.hasAnyDataInNutrientComponentList() && PlessViewUtilsSub.isEmpty(this.kymw1107Model.nutritionalNote)) {
      this.dialogService.openAlertGetMessage('E0250', ['栄養成分値、または栄養成分備考']);
      return;
    }

    // 必須項目のチェック
    // 分析単位
    if (PlessViewUtilsSub.isEmpty(this.kymw1107Model.analysisUnit)) {
      this.dialogService.openAlertGetMessage('E0110', ['分析単位']);
      return;
    }

    const vo: GoodsNutrientRegistModel = this.kymw1107Model.getGoodsNutrientRegistVO();
    // 商品栄養成分情報登録・更新
    this.registNutrientInfoService.execute(this.kymw1107Model, vo);
  }

  /**
   * 「設定」ボタン押下後
   */
  public updateParent(): void {
    const vo: KYMW1107OutputModel = new KYMW1107OutputModel();
    vo.pCode = this.inputVO.pCode;
    vo.itemCode = String(this.inputVO.itemCode);
    vo.analysisSeqNo = this.kymw1107Model.analysisSeqNo;
    vo.analysisUnit = this.kymw1107Model.analysisUnit;
    vo.nutrientNote = this.kymw1107Model.nutritionalNote;

    const tempNutrientList: Array<any> = new Array<any>();
    let tempVO: GoodsNutrientModel;

    for (let i = Number(0); i < this.kymw1107Model.nutrientComponentList.length; i++) {         // 商品栄養成分リスト要素数分ループする

      // ArrayCollectionに追加するVOの生成
      tempVO = new GoodsNutrientModel();
      tempVO.pCode = this.inputVO.pCode;                                                                // Ｐコード
      tempVO.itemCode = String(this.inputVO.itemCode);                                                  // アイテムコード
      tempVO.analysisSeqNo = this.inputVO.analysisSeqNo;                                                // 分析連番
      tempVO.nutritionalCode = this.kymw1107Model.nutrientComponentList[i].NutritionalCode;          // 栄養成分コード
      tempVO.nutritionalName = this.kymw1107Model.nutrientComponentList[i].NutritionalName;          // 栄養成分名
      tempVO.nutritionalQuantity = this.kymw1107Model.nutrientComponentList[i].NutritionalQuantity;  // 栄養成分値
      tempVO.nutrientUnit = this.kymw1107Model.nutrientComponentList[i].NutritionalUnit;             // 栄養成分単位
      tempVO.publishDiv = this.kymw1107Model.nutrientComponentList[i].PublishDiv;                    // 表示区分（0：誌面表示なし、1：あり）
      tempVO.hierarchy = this.kymw1107Model.nutrientComponentList[i].Hierarchy;                      // 階層
      tempNutrientList.push(tempVO);
    }

    vo.nutrientComponentList = tempNutrientList;

    // 親画面に反映
    this.setKYMW1107Parameter(vo);
  }

  /**
   * 栄養成分にデータがあるかどうか判断する。
   */
  public hasAnyDataInNutrientComponentList(): boolean {
    for (let i = Number(0); i < this.kymw1107Model.nutrientComponentList.length; i++) {
      if (this.kymw1107Model.nutrientComponentList[i].NutritionalQuantity) {
        return true;
      }
    }
    return false;
  }
  public nextFocus(event: any): void {
    // 次項目移動の場合（Shiftキー押下時は逆移動の為、制御しない）
    if (event.keyCode === 9 && !event.shiftKey) {
      event.preventDefault();
      // 行が選択されていない場合は1行目を選択状態にする
      if (this.dg_NutrientComponentList.selection.row < 0) {
        this.dg_NutrientComponentList.select(0, 1);
      }
      // 選択行を編集モードに変更する
      this.dg_NutrientComponentList.startEditing(true, this.dg_NutrientComponentList.selection.row, 1, true);
    }
  }

  /**
   * 栄養成分値をフォーカスアウトしたときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   * @param rowIndex 選択した行番号
   */
  public eventQuantity_FOCUSOUTHandler(event: any, cell: any): void {
    const input = event.target as HTMLInputElement;
    if(!input || !cell) {
      return;
    }

    // 入力した文字列の最後の半角/全角スペースを除去
    const strWrd = PlessViewUtilsSub.trimDirection(input.value, 1);
    input.value = strWrd;
    cell.value = strWrd;
    this.dg_NutrientComponentList.setCellData(cell.row.index, 'NutritionalQuantity', strWrd, true);
  }
}
